import Splide from '@splidejs/splide';

(function () {

  const sliders = Array.from(document.querySelectorAll('.key-figures'));

  const exports = {
    initialize: function () {
      if (sliders) {
        sliders.forEach(function(slider) {
          const slides = Array.from(slider.querySelectorAll('.js-splide__slide'));

          let typeSetting = 'loop'
          let maxPerPage = 3;
          let mediumPerPage = 2;

          switch (slides.length) {
            case 1:
              maxPerPage = 1;
              mediumPerPage = 1;
              typeSetting = 'slide'
              break;
            case 2:
              maxPerPage = 2;
              typeSetting = 'slide'
              break;
            default:
              break;
          }

          new Splide(slider, {
            type : typeSetting,
            perPage: maxPerPage,
            pagination: false,
            gap: '1rem',
            breakpoints: {
              1140: {
                perPage: mediumPerPage,
              },
              479: {
                perPage: 1,
              },
            }
          }).mount();
        });
      }
    }
  };

  exports.initialize();

})();
